<div class="footer">&copy; Copyright {{ currentYear }} by Sunflower Lab</div>
